package org.example.zone360.pages.widgets.developmentOrientation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleRight
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.example.zone360.components.widgetTitleFontSize
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.models.WidgetTrend
import org.example.zone360.pages.dashboard.chart.MiniBars
import org.example.zone360.pages.widgets.helper.WidgetTooltipIcon
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.CheckboxInput
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLInputElement

@Composable
fun DevelopmentOrientationWidget(
    widgetNo: Int,
    score: Int,
    clubAvg: Int,
    status: String,
    widgetColor: Color,
    modifier: Modifier = Modifier,
    isCoachPage: Boolean = false,
    sessionBorder: Boolean = false,
    showSelection: Boolean = false,
    forceFullWidth: Boolean = false,
    trendData: List<WidgetTrend> = emptyList(),
    isSelected: Boolean = false,
    onSelectionChange: ((Boolean) -> Unit)? = null,
    tooltipText: String = "",
    tooltipTitle: String = ""
) {
    var widgetDetailResponse by remember { mutableStateOf<WidgetDetailResponse?>(null) }
    var showModal by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var isLoading by remember { mutableStateOf(false) }

    var animatedScore by remember { mutableStateOf(0) }

    LaunchedEffect(score) {

        val start = animatedScore

        repeat(60) { frame ->

            val progress = (frame + 1).toFloat() / 60f

            animatedScore =
                (start + ((score - start) * progress)).toInt()

            delay(20)
        }

        animatedScore = score
    }
    Box(
        modifier = modifier
            .then(
                when {
                    forceFullWidth -> Modifier.fillMaxWidth()   // ✅ session detail
                    sessionBorder -> Modifier.fillMaxWidth()    // ✅ session border card
                    else -> Modifier.minWidth(                  // ✅ normal dashboard
                        when {
                            breakpoint < Breakpoint.MD -> 320.px
                            showSelection -> 280.px
                            window.screen.width in 1200..1500 -> 318.px
                            else -> 350.px
                        }
                    )
                }
            )
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .borderRadius(if (showSelection) 12.px else 16.px)
            .padding(if (showSelection) 12.px else if (sessionBorder) 15.px else 20.px)
            .border(
                if (showSelection) 2.px else if (sessionBorder) 1.px else 0.px,
                LineStyle.Solid,
                color = Palette.CardBorder.rgbLight
            )
            .then(
                when {
                    breakpoint < Breakpoint.MD -> Modifier
                    sessionBorder -> Modifier.height(285.px)
                    !showSelection -> Modifier.height(380.px)
                    else -> Modifier
                }
            )
            .styleModifier {
                property("position", "relative")
            }
    ) {
        if (showSelection) {
            Box(
                modifier = Modifier
                    .styleModifier {
                        property("position", "absolute")
                        property("top", "7px")
                        property("right", "9px")
                        property("cursor", "pointer")
                    }
                    .zIndex(9999)
            ) {

                CheckboxInput(
                    checked = isSelected
                ) {
                    onChange { event ->
                        onSelectionChange?.invoke(
                            (event.target as HTMLInputElement).checked
                        )
                    }

                    style {
                        property("transform", "scale(1.4)")
                        property("cursor", "pointer")
                    }
                }
            }
        }

        Column(
            modifier = Modifier.fillMaxWidth()
                .then(
                    if (breakpoint < Breakpoint.MD) Modifier
                    else Modifier.height(if (showSelection) 350.px else 340.px)
                ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            // HEADER
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth()
            ) {

                Box(
                    modifier = Modifier
                        .width(if (sessionBorder) 24.px else 28.px)
                        .height(if (sessionBorder) 24.px else 28.px)
                        .backgroundColor(widgetColor)
                        .borderRadius(5.px)
                        .margin(right = if (showSelection) 6.px else 10.px),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = widgetNo.toString(),
                        fontSize = 14.px,
                        fontWeight = 700,
                        color = sitePalette.bodyBackground.rgb
                    )
                }

                FieldTitleTextNormalSimple(
                    text = "Development Orientation",
                    fontSize = widgetTitleFontSize(showSelection, sessionBorder, breakpoint),
                    fontWeight = 700
                )
                if (!showSelection) {
                    Box(modifier = Modifier.weight(1f))
                }
                if (tooltipText.isNotEmpty()) {
                    WidgetTooltipIcon(
                        tooltipTitle = tooltipTitle,
                        tooltipText = tooltipText,
                        modifier = Modifier.margin(left = if (showSelection) 3.px else 8.px)
                    )
                }
            }

            // LABELS
            Column(
                modifier = Modifier.fillMaxWidth().height(if (sessionBorder) 230.px else 260.px),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = if (sessionBorder) Arrangement.SpaceAround else Arrangement.Center
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(top = 30.px, bottom = 21.px),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {

                    SpanText(
                        "Win Now",
                        Modifier
                            .fontSize(14.px)
                            .color(Palette.ViewDetailAngle.rgbLight)
                    )

                    SpanText(
                        "Long-Term\nDevelopment",
                        Modifier
                            .fontSize(14.px)
                            .color(Palette.ViewDetailAngle.rgbLight)
                    )
                }

                // BAR
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(12.px)
                        .borderRadius(999.px)
                        .position(Position.Relative)
                ) {

                    Div(
                        attrs = Modifier
                            .fillMaxSize()
                            .borderRadius(6.px)
                            .toAttrs {
                                style {
                                    property(
                                        "background",
                                        "linear-gradient(90deg,#FF3B30 0%,#FF9500 35%,#FFD60A 65%,#22C55E 100%)"
                                    )
                                }
                            }
                    )

                    Box(
                        modifier = Modifier
                            .margin(top = (-6).px)
                            .width(24.px)
                            .height(24.px)
                            .backgroundColor(Colors.White)
                            .borderRadius(50.percent)
                            .position(Position.Absolute)
                            .left(animatedScore.percent)
                            .transform {
                                translateX((-50).percent)
                            }
                            .border(
                                2.px,
                                LineStyle.Solid,
                                color = (Palette.BarColor.rgbLight)
                            )
                            .boxShadow(
                                offsetX = 0.px,
                                offsetY = 2.px,
                                blurRadius = 8.px,
                                color = Color.rgba(0, 0, 0, 0.15f)
                            )
                    )
                }

                // SCORE
                Row(
                    modifier = Modifier.margin(top = if (sessionBorder) 10.px else 26.px),
                    verticalAlignment = Alignment.Bottom
                ) {

                    SpanText(
                        animatedScore.toString(),
                        Modifier
                            .fontSize(if (sessionBorder) 25.px else 36.px)
                            .fontWeight(700)
                            .color(Palette.DevelopmentAverage.rgbLight)
                    )

                    SpanText(
                        "/100",
                        Modifier
                            .margin(bottom = if (sessionBorder) 0.px else 10.px)
                            .fontSize(14.px)
                            .fontWeight(600)
                            .color(Palette.DevelopmentAverage.rgbLight)
                    )
                }

                // STATUS
                val statusBackgroundColor = when (status) {
                    "Accurate" -> Palette.CoachTalkSuccessGreen.rgbLight
                    "High" -> Palette.CoachTalkSuccessGreen.rgbLight
                    "Low" -> Palette.CoachTalkErrorRed.rgbLight
                    else -> Palette.WidgetAverageText.rgbLight
                }

                Row(
                    modifier = Modifier.margin(bottom = 8.px)
                ) {

                    SpanText(
                        "Status: ",
                        Modifier
                            .fontSize(14.px)
                            .fontWeight(700)
                            .color(statusBackgroundColor)
                    )

                    SpanText(
                        status,
                        Modifier
                            .fontSize(14.px)
                            .fontWeight(700)
                            .color(statusBackgroundColor)
                    )
                }
                val avgLabel = when {
                    sessionBorder -> "Avg"
                    isCoachPage -> "Coach Avg"
                    else -> "Club Avg"
                }
                Box(
                    modifier = Modifier
                        .backgroundColor(Palette.WidgetAverageBackground.rgbLight)
                        .borderRadius(99.px)
                        .padding(leftRight = 10.px, topBottom = 4.px),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = "$avgLabel: $clubAvg",
                        fontSize = 11.px,
                        fontWeight = 500,
                        color = Palette.WidgetAverageText.rgbLight
                    )
                }
            }

            Spacer()
            // BUTTON
            if (!sessionBorder) {
                if (isCoachPage) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(top = if (showSelection) 4.px else 30.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Box(
                            modifier = Modifier
                                .cursor(Cursor.Pointer)
                                .margin(top = 4.px)
                        ) {
                            MiniBars(
                                color = widgetColor,
                                trends = trendData
                            )
                        }
                    }
                } else {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(42.px)
//                        .margin(top = if (showSelection) 22.px else 20.px)
                            .backgroundColor(Palette.ViewDetailBackground.rgbLight)
                            .borderRadius(10.px)
                            .border(
                                1.px,
                                LineStyle.Solid,
                                color = Palette.ViewDetailBorder.rgbLight
                            )
                            .cursor(Cursor.Pointer)
                            .onClick {
                                showModal = true
                            }
                    ) {

                        // Centered text
                        Box(
                            modifier = Modifier.fillMaxSize(),
                            contentAlignment = Alignment.Center
                        ) {
                            FieldTitleTextNormalSimple(
                                text = "View Details",
                                fontSize = 14.px,
                                fontWeight = 600,
                                color = Palette.ViewDetailText.rgbLight
                            )
                        }

                        // Right aligned arrow
                        Box(
                            modifier = Modifier
                                .fillMaxHeight()
                                .fillMaxWidth()
                                .padding(right = 14.px),
                            contentAlignment = Alignment.CenterEnd
                        ) {
                            FaAngleRight(
                                modifier = Modifier
                                    .width(14.px)
                                    .height(14.px)
                                    .color(Palette.ViewDetailAngle.rgbLight)
                            )
                        }
                    }
                }
            }
        }
    }
    if (showModal) {
        DevelopmentOrientationDetailsModal(
            widgetNo = widgetNo,
            widgetColor = widgetColor,
            score = score,
            status = status,
            statusColor = Color.rgb(34, 197, 94),
            data = null,
            widgetKey = "development_orientation",
            onClose = { showModal = false }
        )
    }
}

